export enum ConfigMapKey {
    organizationName = "organization_name",
    organizationLogo = "organization_logo",

    incorrectPasswordLimit = "incorrect_password_limit",
    incorrectPasswordLockTime = "incorrect_password_lock_time",

    incorrectTotpLimit = "incorrect_totp_limit",
    incorrectTotpLockTime = "incorrect_totp_lock_time",

    license = "license"
}


export interface GetAllConfigMapsReq{

}
export interface GetAllConfigMapsRes{
    list: GetConfigMapRes[]
}

export interface GetConfigMapReq{
    key: string
}
export interface GetConfigMapRes{
    id: number
    name: string
    key: string
    value: string
    description: string
    unit: string
    min: string
    max: string
}

export interface UpdateConfigMapReq{
    id: number
    name: string
    key: string
    value: string
    description: string
    unit: string
    min: string
    max: string
}
export interface UpdateConfigMapRes{
    success: boolean
}

